/**
 * Une icône par notion, la même partout : navigation, Menu, feuille « Créer »,
 * en-têtes. Deux notions ne partagent jamais une icône (on ne doit pas
 * confondre Contrats et Documents de l'entreprise, ni Clients et Équipe).
 */
import {
  ArrowLeftRight, BarChart3, Bell, BookOpen, Box, Building2, CalendarClock, CalendarDays, CalendarOff, Car,
  ClipboardCheck, Clock, CreditCard, Cylinder, FilePen, FileSpreadsheet, GitMerge, HardHat, Home, Inbox, LifeBuoy, ListChecks, ListTodo,
  Bug, LogOut, MapPin, MapPinHouse, Megaphone, MessageSquareHeart, MessagesSquare, Package, PhoneCall, ReceiptEuro, ScanLine, ScrollText, ShieldCheck, ShoppingCart, Snowflake,
  Settings, UserRound, Users, Wallet, Wrench, type LucideIcon,
} from 'lucide-react';

export const ICONS = {
  accueil: Home,
  planning: CalendarDays,
  demandes: Inbox,
  intervention: Wrench,
  taches: ListTodo,
  clients: Users,
  site: MapPinHouse,
  machine: Box,
  ventes: ReceiptEuro,
  devis: FilePen,
  contrats: ScrollText,
  avis: MessageSquareHeart,
  // Messages (25/10/2026) : conversations de l'équipe, et les annonces de l'entreprise.
  messages: MessagesSquare,
  annonce: Megaphone,
  equipe: HardHat,
  decisions: ClipboardCheck,
  // Astreintes (19/10/2026) : qui répond aux urgences, à appeler.
  astreinte: PhoneCall,
  temps: Clock,
  tempsBloque: CalendarClock,
  absences: CalendarOff,
  stock: Package,
  vehicule: Car,
  mouvement: ArrowLeftRight,
  inventaire: ListChecks,
  achats: ShoppingCart,
  depenses: Wallet,
  fluides: Snowflake,
  bouteille: Cylinder,
  controleEtancheite: ShieldCheck,
  analyses: BarChart3,
  entreprise: Building2,
  abonnement: CreditCard,
  documents: BookOpen,
  // Import Excel/CSV (décision 15 du 19/10/2026).
  import: FileSpreadsheet,
  conflits: GitMerge,
  notifications: Bell,
  compte: UserRound,
  parametres: Settings,
  position: MapPin,
  aide: LifeBuoy,
  // Avis sur MyEquip (24/10/2026), comme le bouton de Claude : signaler un problème ou une idée.
  signaler: Bug,
  deconnexion: LogOut,
  qr: ScanLine,
} as const satisfies Record<string, LucideIcon>;
